import { NAME_SPACE } from './config';
import RidingschoolApp from './RidingschoolApp.vue';

export default {
    name: NAME_SPACE,
    components: {
        'ridingschool-app': RidingschoolApp,
    },
};
